import "./ShipmentCardDashboardTransit.scss";
import ShipmentCardDashboardBase from "../shipment-card-dashboard-base/ShipmentCardDashboardBase";
import { IShipmentCard } from "../../../../../models";

const ShipmentCardDashboardTransit = ({ className, ...rest }: IShipmentCard) => (
    <ShipmentCardDashboardBase className={`ShipmentCardDashboardTransit ${className || ""}`} {...rest} />
);

export default ShipmentCardDashboardTransit;
